
import Vue from "vue";
import Component from "vue-class-component";
import imagemService from "@/services/ImageService";
import { PedidoProduto } from "../../interfaces/Pedido";

@Component({
  name: "ProdutoImagesCarousel",
  components: {},
  props: {
    produto: {
      type: Object as () => PedidoProduto,
    },
    imageHeight: {
      type: String,
      required: true,
    },
  },
})
export default class ProdutoImagesCarousel extends Vue {
  get produtoImages() {
    return imagemService.getProdutoImages(this.$props.produto);
  }
}
